(function () {
    'use strict';

    var badgeRoot = '/images/badges/',
        gettext = angular.identity;

    angular
        .module('app.home')
        .constant('noopUrl', 'javascript:void(0)')
        .constant('tweetUrl', 'https://twitter.com/intent/tweet')
        .constant('facebookUrl', 'https://www.facebook.com/sharer.php?u=')
        .constant('badgeDefinitions', {
            openingRound: {
                image: badgeRoot + 'FOURSQUARE-OpeningRound.png',
                imageGray: badgeRoot + 'FOURSQUARE-OpeningRound-Gray.png',
                title: gettext('Opening Round'),
                unearned: gettext('<strong>Opening Round</strong><br>Unlock this badge when you post your first score.'),
                earned: gettext('<strong>Opening Round</strong><br>This badge is awarded to everyone when they post their first score of the season.'),
                twitter: gettext('I just posted my Opening Round. Track your game for free @TheGolfCanada golfcanada.ca/join'),
                facebook: gettext('I just posted my Opening Round. Track your game for free at the Golf Canada Score Center golfcanada.ca/join')
            },

            handicap: {
                image: badgeRoot + 'FOURSQUARE-Handicap.png',
                imageGray: badgeRoot + 'FOURSQUARE-Handicap-Gray.png',
                title: gettext('Handicap'),
                unearned: gettext('<strong>Handicap</strong><br>Post 5 scores to begin maintaining your Official Handicap Factor®'),
                earned: gettext('<strong>It’s Official</strong><br>Congratulations, you’ve earned an Official Golf Canada Handicap Factor®'),
                twitter: gettext('I’ve earned my Official @TheGolfCanada Handicap Factor! Learn how Handicapping makes golf more fun at golfcanada.ca/officialhandicap'),
                facebook: gettext('I’ve earned my Official Golf Canada Handicap Factor! Learn how Handicapping makes golf more fun at golfcanada.ca/officialhandicap')
            },

            oneHundred: {
                image: badgeRoot + 'FOURSQUARE-Break100.png',
                imageGray: badgeRoot + 'FOURSQUARE-Break100-Gray.png',
                title: gettext('Scoring Milestone'),
                unearned: gettext('<strong>Score Milestone</strong><br>How low can you go?'),
                earned: gettext('<strong>Rare Company!</strong><br>Congratulations, less than 10% of golfers ever break 100!'),
                twitter: gettext('Check out my latest scoring badge! Unlock achievements and track your game for free @TheGolfCanada golfcanada.ca/trackyourgame'),
                facebook: gettext('Check out my latest scoring badge! Unlock achievements and track your game for free at the Golf Canada Score Center golfcanada.ca/trackyourgame')
            },

            ninety: {
                image: badgeRoot + 'FOURSQUARE-Break90.png',
                imageGray: badgeRoot + 'FOURSQUARE-Break90-Gray.png',
                title: gettext('Scoring Milestone'),
                unearned: gettext('<strong>Score Milestone</strong><br>How low can you go?'),
                earned: gettext('<strong>Rare Company!</strong><br>Congratulations, less than 10% of golfers ever break 100!'),
                twitter: gettext('Check out my latest scoring badge! Unlock achievements and track your game for free @TheGolfCanada golfcanada.ca/trackyourgame'),
                facebook: gettext('Check out my latest scoring badge! Unlock achievements and track your game for free at the Golf Canada Score Center golfcanada.ca/trackyourgame')
            },

            eighty: {
                image: badgeRoot + 'FOURSQUARE-Break80.png',
                imageGray: badgeRoot + 'FOURSQUARE-Break80-Gray.png',
                title: gettext('Scoring Milestone'),
                unearned: gettext('<strong>Score Milestone</strong><br>How low can you go?'),
                earned: gettext('<strong>Rare Company!</strong><br>Congratulations, less than 10% of golfers ever break 100!'),
                twitter: gettext('Check out my latest scoring badge! Unlock achievements and track your game for free @TheGolfCanada golfcanada.ca/trackyourgame'),
                facebook: gettext('Check out my latest scoring badge! Unlock achievements and track your game for free at the Golf Canada Score Center golfcanada.ca/trackyourgame')
            },

            seventy: {
                image: badgeRoot + 'FOURSQUARE-Break70.png',
                imageGray: badgeRoot + 'FOURSQUARE-Break70-Gray.png',
                title: gettext('Scoring Milestone'),
                unearned: gettext('<strong>Score Milestone</strong><br>How low can you go?'),
                earned: gettext('<strong>Rare Company!</strong><br>Congratulations, less than 10% of golfers ever break 100!'),
                twitter: gettext('Check out my latest scoring badge! Unlock achievements and track your game for free @TheGolfCanada golfcanada.ca/trackyourgame'),
                facebook: gettext('Check out my latest scoring badge! Unlock achievements and track your game for free at the Golf Canada Score Center golfcanada.ca/trackyourgame')
            },

            birdie: {
                image: badgeRoot + 'FOURSQUARE-Birdie.png',
                imageGray: badgeRoot + 'FOURSQUARE-Birdie-Gray.png',
                title: gettext('Birdie'),
                unearned: gettext('<strong>Birdie</strong><br>We’re as proud of these as you are so we’re going to track them all.'),
                earned: gettext('<strong>Tweet Tweet</strong><br>This one’s worth bragging about!'),
                twitter: gettext('Got my Birdie Badge! Track your game for free @TheGolfCanada golfcanada.ca/trackyourgame'),
                facebook: gettext('Got my Birdie Badge! Track your game for free at the Golf Canada Score Center golfcanada.ca/trackyourgame')
            },

            holeInOne: {
                image: badgeRoot + 'FOURSQUARE-HoleInOne.png',
                imageGray: badgeRoot + 'FOURSQUARE-HoleInOne-Gray.png',
                title: gettext('Hole in One'),
                unearned: gettext('<strong>Hole in One</strong><br>The holy grail!'),
                earned: gettext('<strong>Boom!</strong><br>Congratulations on your hole-in-one!'),
                twitter: gettext('Boom! Hole-In-One! Track your game for free @TheGolfCanada golfcanada.ca/trackyourgame'),
                facebook: gettext('Boom! Hole-In-One! Track your game for free at Golf Canada\'s Score Center: golfcanada.ca/trackyourgame')
            },

            weekendWarrior: {
                image: badgeRoot + 'FOURSQUARE-WeekendWarrior.png',
                imageGray: badgeRoot + 'FOURSQUARE-WeekendWarrior-Gray.png',
                title: gettext('Weekend Warrior'),
                unearned: gettext('<strong>Weekend Warrior</strong><br>Play 3 consecutive weekends to earn this badge.'),
                earned: gettext('<strong>Saturgolfday</strong><br>Wow! 3 consecutive weekend rounds.'),
                twitter: gettext('I got my Weekend Warrior badge! Unlock achievements and track your game for free @TheGolfCanada golfcanada.ca/trackyourgame'),
                facebook: gettext('Warrior badge! Unlock achievements and track your game for free at the Golf Canada Score Center golfcanada.ca/trackyourgame')
            },

            playingHooky: {
                image: badgeRoot + 'FOURSQUARE-PlayingHookie.png',
                imageGray: badgeRoot + 'FOURSQUARE-PlayingHookie-Gray.png',
                title: gettext('Playing Hooky'),
                unearned: gettext('<strong>Playing Hooky</strong><br>Post 3 weekday scores. Don’t worry, we won’t tell.'),
                earned: gettext('<strong>NSFW!</strong><br>Playing hooky? This might be the badge we advise you not to share on Facebook.'),
                twitter: gettext('A bad day beats a good day in the office. Track your game for free @TheGolfCanada golfcanada.ca/trackyourgame'),
                facebook: gettext('A bad day beats a good day in the office. Track your game for free at the Golf Canada Score Center golfcanada.ca/trackyourgame')
            },

            globalGolfer: {
                image: badgeRoot + 'FOURSQUARE-GlobalGolfer.png',
                imageGray: badgeRoot + 'FOURSQUARE-GlobalGolfer-Gray.png',
                title: gettext('Global Golfer'),
                unearned: gettext('<strong>Global Golfer</strong><br>Pack your clubs and post a score outside of Canada.'),
                earned: gettext('<strong>Bon Voyage!</strong><br>Congratulations, you’ve earned your Global Golfer badge.'),
                twitter: gettext('Bon Voyage! Earn your own #GlobalGolfer badge like me with your free @TheGolfCanada membership golfcanada.ca/trackyourgame'),
                facebook: gettext('Bon Voyage! Earn your own Global Golfer badge like me with your free Golf Canada membership golfcanada.ca/trackyourgame')
            },

            tournament: {
                image: badgeRoot + 'FOURSQUARE-Tournament.png',
                imageGray: badgeRoot + 'FOURSQUARE-Tournament-Gray.png',
                title: gettext('Tournament'),
                unearned: gettext('<strong>Tournament Medal</strong><br>Post your first tournament score and unlock this achievement.'),
                earned: gettext('<strong>Tournament Medal</strong><br>Thanks for participating in one of our Golf Canada tournaments.'),
                twitter: gettext('Had a great time playing in @TheGolfCanada amateur championship. Check out the event schedule here golfcanada.ca/competitions'),
                facebook: gettext('Had a great time playing in Golf Canada’s amateur championship. Check out the event schedule here golfcanada.ca/competitions')
            }
        })
        .constant('memberBenefitsTemplateUrl', 'app/home/member-benefits/member-benefits.component.{0}.html')

        .enumeration('golfActivityType', {
            HandicapRound: [, gettext('Handicap Round')],
            Recreational: [, gettext('Recreational (no score posted)')],
            Fundraising: [, gettext('Fundraising (no score posted or team score)')],
            Partialround: [, gettext('Partial round')],
            PitchAndPutt: [, gettext('Pitch and Putt')],
            DrivingRange: [, gettext('Driving range')],
            PracticePutt: [, gettext('Practice Putt')],
            Practicechip: [, gettext('Practice chip')],
            ShortGamePractice: [, gettext('Short Game Practice')],
            Lesson: [, gettext('Lesson')],
            GolfSimulator: [, gettext('Golf Simulator')],
            DiscGolf: [, gettext('Disc Golf')],
            FootGolf: [, gettext('Foot Golf')],
            EventVolunteer: [, gettext('Event Volunteer')],
            Spectator: [, gettext('Spectator (non tv)')],
            Caddy: [, gettext('Caddy')],
            WatchingChild: [, gettext('Watching Child')]
        })
        .constant('defaultActivitiesPageSize', 10)
        .constant('home_resources', {
            ultimateFacilitiesRequestFailed: gettext('Failed to retrieve clubs for member.'),
            ultimateScorecardRequestFailed: gettext('Failed to retrieve scorecard.'),
            badgesRequestFailed: gettext('Failed to retrieve badges.'),

            cancelSubscriptionSucceeded: gettext('Your auto-renewal has been canceled'),
            cancelSubscriptionFailed: gettext('Failed to cancel your auto-renewal.  Please contact customer support.'),

            activitiesRequestFailed: gettext('Failed to retrieve activities.'),
            activitySaveFailed: gettext('Failed to save activity.'),
            activityDeleteConfirmation: gettext('Are you sure you want to remove this activity?'),
            activityDeleteFailed: gettext('Failed to delete activity'),

            clubTransferSuccess: gettext('Your transfer request has been sent.'),
            clubTransferFailed: gettext('Failed to send a transfer request.'),

            clubRosterRequestFailed: gettext('Failed to retrieve member roster from server.'),
            confirmRemoveCourseListItem: gettext('Are you sure you want to remove "{0}" from the course list?'),
            addToCourseListFailed: gettext('Failed to add "{0}" to the course list!'),
            removeFromCourseListFailed: gettext('Failed to remove "{0}" from the course list!')
        })
        .constant('defaultClubRosterPageSize', 10)
        .constant('clubRosterSearchPlaceholder', gettext('Enter "last, first name" or card #.'));
})();